export class RansomwareResourceNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RansomwareResourceNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
